<template>
    <div class="inside_pages_right">
        <div class="inside_pages_right_top">
           <div class="inside_header_title">任务模板</div>
        </div>
        <div class="inside_pages_right_content">
            <div class="inside_pages_right_content_top ">
                <div class="inside_pages_right_content_top_left">
                    <el-button type="primary" size="mini"  icon="el-icon-circle-plus-outline">新建任务模版</el-button>
                    <el-button type="danger" size="mini"  icon="el-icon-circle-close">删除</el-button>
                </div>
                <div class="inside_pages_right_content_top_right">
                    <el-input v-model.trim="requestData.name"  size="mini" placeholder="任务名称"></el-input> &nbsp;
                    <el-button size="mini" type="primary" plain icon="el-icon-search">搜索</el-button>
                </div>
            </div>
            <div class="inside_pages_right_content_center" >
                <el-table :data="responseData.list"  height="100%" border style="width: 100%" @selection-change="selectListData">
                    <el-table-column type="selection" width="40">
                    </el-table-column>
                    <el-table-column prop="id" label="编号" width="80">
                    </el-table-column>

                    <el-table-column prop="name1" label="任务名称">
                    </el-table-column>

                    <el-table-column prop="name2" label="任务类型">
                    </el-table-column>

                    <el-table-column prop="name3" label="填报人员类型">
                    </el-table-column>

                    <el-table-column  prop="date1" label="开始时间" width="160">
                        <template slot-scope="rowData">
                            {{$Common.dateFormatDateTwo(rowData.row.date1)}}
                        </template>
                    </el-table-column>

                    <el-table-column  prop="date2" label="结束时间" width="160">
                        <template slot-scope="rowData">
                            {{$Common.dateFormatDateTwo(rowData.row.date2)}}
                        </template>
                    </el-table-column>

                    <el-table-column  label="操作">
                        <template slot-scope="scope">
                            <el-button  type="primary" plain  size="mini"   icon="el-icon-document">
                                创建学生任务
                            </el-button>

                            <el-button  type="primary" plain  size="mini"   icon="el-icon-document">
                                删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="inside_pages_right_content_bottom" v-if="responseData.total > 0">
               <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="responseData.pageNum"
                    :page-sizes="[20, 30, 50, 100]"
                    :page-size="20"
                    layout="total, sizes, prev, pager, next, jumper"
                    prev-text="上一页"
                    next-text="下一页"
                    :total="responseData.total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'',
    components: {},
    props: {},
    data() {
        return {
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
                shortcuts: [{
                    text: '今天',
                    onClick(picker) {
                    picker.$emit('pick', new Date());
                    }
                }, {
                    text: '昨天',
                    onClick(picker) {
                    const date = new Date();
                    date.setTime(date.getTime() - 3600 * 1000 * 24);
                    picker.$emit('pick', date);
                    }
                }]
            },
            // 请求参数
            requestData :{
                schoolId : this.$store.state.schoolId,
                pageNum : 1,
                pageSize : 20,
                date:null,
                type:null,
                name:null,

            },
            // 数据列表
            responseData: {
                pageNum:1,        // 第几页
                pageSize:20,      // 一页多少个
                total:0,      // 总条数
                pages:0,     // 总页数
                list:[
                    {
                        id:2,
                        name1: '填表',
                        name2: '调查类',
                        name3: '校领导',
                        date1: 1593273599,
                        date2: 1593273599,
                    }
                ],
            },

            selectedListData:[],


        };
    },
    watch: {},
    computed: {},
    methods: {
        selectListData(data){
            this.selectedListData = []
            data.forEach(element => {
                this.selectedListData.push(
                    element.roleId
                )
            });

            // console.log(this.selectedListData);
        },
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
        }

    },
    created() {},
    mounted() {

    }
};
</script>
